import { balanceUpdaterService } from "@shared/services";
import { TExternalCallback } from "@shared/services/types";
import React, { useEffect } from "react";

/**
 * @function useRegisterUpdateGameBalanceService
 * @param registerCallback - callback for reactive updating balance in your app
 */
export function useRegisterUpdateGameBalanceService({
  registerCallback,
}: {
  registerCallback: TExternalCallback;
}): void {
  const refCallback = React.useRef<TExternalCallback>(registerCallback);

  balanceUpdaterService.updateExternalCallback = refCallback.current;

  useEffect(() => {
    balanceUpdaterService.init();
    return () => balanceUpdaterService.dispose();
  });
}
